import React from 'react'
import './Results.css'

export default function Traitdescription(props) {
  return <div className="align-center">
      <p>{props.description}</p>
    </div>
}